import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { ToastService } from '@y42/toast';
import { catchError, map, of } from 'rxjs';
import { LogModel } from '../state';

@Injectable({ providedIn: 'root' })
export class LogsHistoryService {
  constructor(private readonly http: HttpClient, private readonly toast: ToastService) {}

  getHistoryFromChannel(channelName: string, params = {}) {
    return this.http.get<Array<{ event: string; data: LogModel }>>(`${this.getUrl()}/${channelName}`, { params }).pipe(
      map((logs) => logs.map((log) => log.data)),
      catchError(() => {
        this.toast.error('Could not fetch logs');
        return of([] as LogModel[]);
      }),
    );
  }

  markAsRead(id: string) {
    return this.http.put<void>(`${this.getUrl()}/${id}/read`, {});
  }

  private getUrl(): string {
    return `${environment.url.ws_events_api}/history`;
  }
}
